import React from "react";
import DeleteIcon from "@/assets/icons/deleteIcon";
import {
  ContentWrapper,
  HeadingWrapper,
  MainLayout,
  NotesWrapper,
  PriceHeadingWrapper,
  PriceWrapper,
} from "./styles";

const ExpandedRowTableContent = ({ description, msrp }) => {
  return (
    <MainLayout>
      <NotesWrapper>
        <HeadingWrapper>{`Description`}</HeadingWrapper>
        <ContentWrapper>{description}</ContentWrapper>
      </NotesWrapper>
      <NotesWrapper>
        <PriceHeadingWrapper>{`MSRP`}</PriceHeadingWrapper>
        <PriceWrapper>{msrp}</PriceWrapper>
      </NotesWrapper>
      <div style={{ cursor: "pointer" }}>
        <DeleteIcon />
      </div>
    </MainLayout>
  );
};

export default ExpandedRowTableContent;
